<div class="c07-tv-intro-screen" data-animation="content-wrapper">
  <picture *ngFor="let imageLink of imageLinks">
    <source srcset="{{ imageLink.webpSrc }}" type="image/webp" />
    <source srcset="{{ imageLink.src }}" type="image/jpeg" />
    <img
      alt=""
      [attr.data-animation]="imageLink.dataAnimation"
      class="{{ imageLink.class }}"
      src="{{ imageLink.src }}"
    />
  </picture>
</div>
